import React, { useState } from "react";
import styled from "styled-components";
import { CorporateTheme } from "../../utils/themes";
import PolygonIcon from "../../assets/icons/PolygonIcon";
import { useTheme } from "../../middleware/ThemeContext";

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const ValueDisplay = styled.span`
  border: 0.4px solid ${({theme}) => theme.CorporateTheme?.colors?.border};
  font-size: 12px;
  font-weight: 500;
  min-width: 100px;
  color:#748096;
  min-height: 36px;
  text-align: center;
  padding: 5px;
  border-radius:5px;
`;

type StyledStepperProps = {
  label: string;
  min: number;
  max: number;
  onChange?: (val: number) => void;
  defaultVal?:number;
};

const StyledStepper = ({defaultVal, label, min, max, onChange }: StyledStepperProps) => {
  const {theme} = useTheme();
  const [value, setValue] = useState(defaultVal?defaultVal:min);

  const updateValue = (newVal: number) => {
    setValue(newVal);
    onChange?.(newVal);
  };

  const increment = () => {
    if (value < max) updateValue(value + 1);
  };

  const decrement = () => {
    if (value > min) updateValue(value - 1);
  };

  return (
    <Wrapper>
      <ValueDisplay theme={theme} className="d-flex gap-2 align-items-center justify-content-between ps-3">
        {value} {value === 1 ? label : `${label}s`}
        <div className="d-flex flex-column justify-content-end cursor-pointer">
          <PolygonIcon
            rotate="up"
            onClick={increment}
            disabled={value >= max}
          />
          <PolygonIcon
            rotate="down"
            onClick={decrement}
            disabled={value <= min}
          />
        </div>
      </ValueDisplay>
    </Wrapper>
  );
};

export default StyledStepper;
